import React, { type FunctionComponent } from "react";
import { Progress, Space, Statistic } from "antd";
import { useTranslation } from "react-i18next";

import {
  ClientImportAggregation,
  type ProductClientsImportAggregation,
} from "@fitness-app/data-models/entities/ProductClientToImport";

interface OwnProps {
  aggregation: ProductClientsImportAggregation;
}

/** The counters of one import, shared by the stepper's last step and the import details. */
export const ImportSummaryCounters: FunctionComponent<OwnProps> = ({ aggregation }) => {
  const { t } = useTranslation("products");
  const inProgress = aggregation.status === ClientImportAggregation.InProgress;
  const percent = aggregation.total ? Math.round((aggregation.processed / aggregation.total) * 100) : 100;

  return (
    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      <Progress
        percent={percent}
        status={inProgress ? "active" : aggregation.failed ? "exception" : "success"}
        format={() => `${aggregation.processed} / ${aggregation.total}`}
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <Statistic title={t("import.summary.total")} value={aggregation.total} />
        <Statistic
          title={t("import.summary.imported")}
          value={aggregation.imported}
          valueStyle={{ color: "#16a34a" }}
        />
        <Statistic
          title={t("import.summary.skipped")}
          value={aggregation.skipped}
          valueStyle={{ color: aggregation.skipped ? "#ca8a04" : undefined }}
        />
        <Statistic
          title={t("import.summary.failed")}
          value={aggregation.failed}
          valueStyle={{ color: aggregation.failed ? "#dc2626" : undefined }}
        />
      </div>
    </Space>
  );
};
